import { render, staticRenderFns } from "./FilterCardPaginationMenuFilterElement.vue?vue&type=template&id=0baa9836"
import script from "./FilterCardPaginationMenuFilterElement.vue?vue&type=script&lang=ts"
export * from "./FilterCardPaginationMenuFilterElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports